import {
  GET_PROGRAM_PATH,
  CHANGE_LESSON_STATUS_LESSON_PATH,
  GET_QUIZ_PATH,
  SAVE_QUIZ_PATH,
  GET_REWARDS_PATH,
  GET_USER_REWARD_PATH,
} from '../../constants'
import AbstractService from '../../services/AbstractService'
import { ServerResponse } from '../../types'

import {
  LessonPageData,
  LessonRequestData,
  ProgramData,
  QuizData,
  QuizRequestData,
  RewardsData,
  SaveQuizRequestData,
  SaveQuizResponseData,
  UserRewardRequestData,
  UserRewardResponseData,
} from './types'

class EducationServiceClass extends AbstractService {
  getPrograms = () =>
    this.request<ServerResponse<ProgramData[]>>(GET_PROGRAM_PATH, 'get', true, null)

  changeLessonStatus = (data: LessonRequestData) =>
    this.request<ServerResponse<LessonPageData>>(
      CHANGE_LESSON_STATUS_LESSON_PATH,
      'post',
      true,
      data,
    )

  getQuiz = (data: QuizRequestData) =>
    this.request<ServerResponse<QuizData>>(GET_QUIZ_PATH, 'post', true, data)

  sendQuiz = (data: SaveQuizRequestData[]) =>
    this.request<ServerResponse<SaveQuizResponseData>>(SAVE_QUIZ_PATH, 'post', true, data)

  getRewards = () =>
    this.request<ServerResponse<RewardsData[]>>(GET_REWARDS_PATH, 'get', true, null)

  getUserReward = (data: UserRewardRequestData) =>
    this.request<ServerResponse<UserRewardResponseData>>(GET_USER_REWARD_PATH, 'post', true, data)
}

export const EducationService = new EducationServiceClass()
